var exports = {
  "n": "x127c5a35--959177--row",
};

module.exports = exports;
